// The Navbar on smaller screen sizes
import React, { useState, useEffect } from 'react';
import CSUSLogo from '../../Assets/CSUS_logo.png';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBars} from '@fortawesome/free-solid-svg-icons'
import '../Styles/MobileNavbar.css';

const useActiveLink = () => {
    const [activeLink, setActiveLink] = useState(null);
    const pathName = window.location.pathname + window.location.hash
  
    useEffect(() => {
      // Map the links in the navbar to their corresponding routes
      const links = [
        { name: 'Home', route: '/' },
        { name: 'Team', route: '/#team' },
        { name: 'Events', route: '/#events' },
        { name: 'Contact', route: '/#contact' },
        { name: 'Resources', route: '/resources' },
        { name: 'Resources', route: '/resources#academic-resources' },
        { name: 'Resources', route: '/resources#recruiting-resources' },
        { name: 'Resources', route: '/resources#event-resources' },
        { name: 'Resources', route: '/resources#constitution' }
      ];
  
      const matchingLink = links.find(link => link.route === pathName);
  
      if (matchingLink) {
        // Set the active link if there is a match
        setActiveLink(matchingLink.name);
      } else {
        setActiveLink(null);
      }
    }, [pathName]);
  
    return activeLink;
  };

const MobileNavbar = () => {
    const [showMenu, setShowMenu] = useState(false)
    const activeLink = useActiveLink();
    const baseUrl = window.location.origin

    let menu
    let menuMask

    if(showMenu){
        menu = (
            <div className="menu">
              <a onClick={() => setShowMenu(false)} className={`mobile_navbar_link ${activeLink === 'Home' ? 'active' : ''}`} href={`${baseUrl}/`}>
                Home
              </a>
              <a onClick={() => setShowMenu(false)} className={`mobile_navbar_link ${activeLink === 'Team' ? 'active' : ''}`} href={`${baseUrl}/#team`}>
                Team
              </a>
              {/* <a onClick={() => setShowMenu(false)} className={`mobile_navbar_link ${activeLink === 'Events' ? 'active' : ''}`} href={`${baseUrl}/#events`}>
                Events
              </a> */}
              <a onClick={() => setShowMenu(false)} className={`mobile_navbar_link ${activeLink === 'Contact' ? 'active' : ''}`} href={`${baseUrl}/#contact`}>
                Contact
              </a>
              {/* <a onClick={() => setShowMenu(false)} className={`mobile_navbar_link ${activeLink === 'Resources' ? 'active' : ''}`} href={`${baseUrl}/resources`}>
                Resources
              </a> */}
            <a href="https://westernusc.store/product/computer-science/"><button className="mobile_join_button" >Join now</button></a>
            </div>
          );

        menuMask = 
        <div className="menu_mask" onClick={() => setShowMenu(false)}>

        </div>
    }

    return ( 
        <div className="mobile_navbar">
            <img className="mobile_navbar_logo" src={CSUSLogo} alt="CSUS_logo"/>

            <FontAwesomeIcon className='icon' size="xl"
                icon={faBars}
                onClick = {() => setShowMenu(!showMenu)}
            />
            {menuMask}
            {menu}
        </div>
    );
}
 
export default MobileNavbar;
